<template>
  <div class="container-fluid">
    <template v-for="(disc, discId) in possibleItems.list">
      <div class="row" v-bind:key="discId">
        <div class="col-9 color-disc" @click="editDisc = discId">
          <template v-if="discId === 'all'">
            <h5>{{ $t("Menu.list.colors.allDiscs") }}</h5>
            <p><br /></p>
          </template>
          <template v-else>
            <h5 v-if="isAlloyCombi === true">
              <template v-if="discId != 1">{{
                $t("Common.ringLayout.alloyCombi")
              }}</template>
              <template v-else>{{ $t("Common.jewelleryType.0") }}</template>
            </h5>
            <h5
              v-else-if="
                currentItem &&
                currentItem.description &&
                (
                  currentItem.description.jewelleryType === 11 ||
                  currentItem.description.jewelleryType === 21 ||
                  currentItem.description.jewelleryType === 22 ||
                  currentItem.description.jewelleryType === 4 ||
                  currentItem.description.jewelleryType === 1 ||
                  currentItem.description.jewelleryType === 7
                )
              "
            >
              {{ $t("Set.Item.Description.color") }}
            </h5>
            <h5 v-else-if="ringLayout === 22">
              {{
                $tc(
                  "Common.ringLayout." + ringLayout,
                  possibleItems.list.length > 2 && discId === 1
                    ? 0
                    : parseInt(discId) + 1
                )
              }}
            </h5>
            <h5 v-else>
              {{ $tc("Common.ringLayout." + ringLayout, parseInt(discId) + 1) }}
            </h5>
            <template v-for="(item, index) in disc">
              <p
                class="text-start"
                v-bind:key="index"
                v-if="item.match && editDisc !== discId"
                @click="editDisc = discId"
              >
                {{ item.text }}
              </p>
            </template>
          </template>
        </div>
        <div class="col-3 text-end">
          <img
            :src="appUrl + '/img/icons/edit.svg'"
            class="icon open"
            v-if="editDisc != discId || editDisc === false"
            @click="editDisc = discId"
            alt="edit"
          />
          <img
            :src="appUrl + '/img/icons/close.svg'"
            class="icon"
            v-if="editDisc == discId && editDisc !== false"
            @click="editDisc = false"
            alt="close"
          />
        </div>
        <div class="col-12" v-if="editDisc == discId">
          <ul class="default-option-list colors">
            <template v-for="(item, index) in colorList">
              <li
                v-bind:key="index"
                @click="changeItem(item.itemnumber, item.alerts)"
                class="pointer"
                :class="{ match: item.match, 'has-alloy-combi': isAlloyCombi }"
              >
                <img
                  class="thumb"
                  @error="
                    $parent.setIconNotAvailable(
                      $refs[
                        'color' + index + '_' + item.finish + '_' + item.color
                      ]
                    )
                  "
                  :ref="'color' + index + '_' + item.finish + '_' + item.color"
                  :src="
                    $parent.getFinishIcon(
                      item.finish,
                      item.color,
                      item.itemnumber,
                      false
                    )
                  "
                  :srcset="
                    $parent.getFinishIcon(
                      item.finish,
                      item.color,
                      item.itemnumber,
                      true
                    )
                  "
                  :alt="item.text"
                />
                <p>{{ item.text }}</p>
              </li>
            </template>
            <li v-if="!allColors" @click="allColors = true">
              <img
                class="thumb"
                :src="appUrl + '/img/icons/next.svg'"
                alt="more"
              />
              {{ $t("Menu.list.colors.next") }} &gt;
            </li>
          </ul>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import Config from "@/vuex/Config";
import SetData from "@/vuex/SetData";

export default {
  name: "VariationsColors",
  props: ["possibleItems"],
  data() {
    return {
      appUrl: Config.getters.getAppUrl,
      editDisc: "0",
      allColors: true,
      ringLayout: SetData.getters.getRingLayout,
      currentItem: SetData.getters.getCurrentItem,
      currentItemId: SetData.getters.getCurrentItemId,
      maxItems: 99,
    };
  },
  methods: {
    changeItem: function (itemnumber, alerts) {
      this.$parent.$parent.changeItem(itemnumber, alerts);
    },
    configure: function (type) {
      this.$root.$emit("configure", type);
    },
  },
  updated() {
    if (this.possibleItems.list.length === 1) {
      this.editDisc = "0";
    }
  },
  computed: {
    isAlloyCombi: function () {
      return this.$parent.$parent.$parent["isCurrentItemAlloyCombi"](
        SetData.getters.getCurrentItemId
      );
    },
    colorList: function () {
      let list = {};

      if (typeof this.possibleItems.list[this.editDisc] === "object") {
        let counter = 0;

        for (let key in this.possibleItems.list[this.editDisc]) {
          if (
            Object.prototype.hasOwnProperty.call(
              this.possibleItems.list[this.editDisc],
              key
            )
          ) {
            if (this.allColors === true || counter < this.maxItems) {
              list[key] = this.possibleItems.list[this.editDisc][key];
              counter++;
            }
          }
        }
      }

      return list;
    },
  },
  watch: {
    editDisc: {
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          if (this.editDisc !== false) {
            let length = Object.keys(
              this.possibleItems.list[this.editDisc]
            ).length;
            this.allColors = length <= this.maxItems + 1;
          } else {
            this.allColors = true;
          }
        }
      },
      deep: true,
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
#app {
  ul.default-option-list.colors {
    padding: 0;
  }

  .color-disc {
    cursor: pointer;
  }
}
</style>
